import React from "react";
import { connect } from "react-redux";
import mapStateToProps from "reducers/actions/stateToProps";
import mapDispatchToProps from "reducers/actions/dispatchProps";
import { withSnackbar } from "notistack";
import { AccountHandler, ChitEngine } from "chits-data/dist";
import { Button } from "@material-ui/core";
import { WebClientStore } from "web-client-store";
import moment from "moment";
import NewChitTermForm from "./NewChitTermForm";
import Constants from "components/utils/constants";
import { withTranslation } from "react-i18next";
let console = Constants.consoleWrapper(false);
class Manage extends React.Component {
  constructor(props) {
    super(props);
    this._accountHandler = new AccountHandler();
    this._engine = new ChitEngine();
  }

  state = {
    enableAddChitTerm: false,
    tranTypeMap: {},
    termDateMap: {},
    termCountMap: {},
    tranIndexes: [],
    card_2_open: true
  }

  componentDidMount = () => {
    //TODO: If this page accessed without account set; redirect to /info
    let ac = this._accountHandler.getActiveAccount();
    // // asynchronously load account information to props
    this._accountHandler.getAccountCached(ac).then((account) => {
      this.props.setCurrentAccount(account);
    });

    // Call ChitEngine to gather key information about chit
    this._engine.prepareChitTransactions(false).then(stateData => this.setState(stateData));
  };


  _force_reload_account = (redirect='/transactions?refresh=manage_new_chit') => {
      let id = this.props.wallet.current._id;
      return (
          this._accountHandler.getAccountCached(id, true).then((ac)=>{
              // this.setState({ selectedAccount: ac });
              Constants.requestPaymentDashboardRefresh(id).then(()=>{
                // force-refresh transactions on next visit to transactions page
                Constants.requestTranRefresh(id);
                // WebClientStore.Session.set(id + '_req_ts', moment().format('YYYYMMDDhhmmss'));
                // window.location.reload();
                window.location.href = redirect
              })
          })
      )
  }

  renderModalNewChitTermTran(nextTermDate) {
    // let selected = this.gridApi.getSelectedRows();
    // let newTran = _cloneDeep(tranObject);
    // console.log("adding selected row date to new tran dialog:" + JSON.stringify(selected));
    // if (Array.isArray(selected) && selected.length === 1 && selected[0].date) {
    //     newTran.date.value = selected[0].date.substr(0, 10);
    // } 
    return (
      <NewChitTermForm
        display={this.state.enableAddChitTerm}
        onCancel={() => {
          this.setState({ enableAddChitTerm: false });
        }} 
        onSubmit={() => {
          this.setState({ enableAddChitTerm: false });
          this._force_reload_account('/transactions?refresh=new_term')
        }} 
        modeUpdate={false}
        asDialog={true}
        nextTermDate={nextTermDate}
      />
    )
  }


	handleDeleteLastTerm = (chitTerm=-1) => {
		// this.setState({
		// 	openOverlay : true
		// });
		this._accountHandler.getInstance()
			.post(`${Constants.URLs.TRANS}/resetchitterm/ac/${this.props.wallet.current._id}`, {})
			.then(async (response) => {
				// this.props.enqueueSnackbar('Last term deleted successfully', {
				// 	variant : 'success'
				// });
			})
			.catch((error) => {
				console.log(error);
        let msg = 'An error occurred from the server';
        try {
            if (error.response.data.message) msg = error.response.data.message
        } catch (error) {}
				// this.props.enqueueSnackbar(msg, {
				// 	variant : 'error'
				// });
			})
			.finally(()=>{
				// this.setState({
				// 	openOverlay: false
				// });
        // If use withdrawn first term itself; navigate back to manage page
        // Since there is no term available to show in transactoins page.
        if (chitTerm === 1) {
          this._force_reload_account('/manage?refresh=delete_term');
        } 
        // Otherwise show the transactions page
        else {
          this._force_reload_account('/transactions?refresh=delete_term');
        }
				
			})
	}



  render() {
    let { termDateMap, card_2_open } = this.state;
    let { wallet, t } = this.props;
    let { current } = wallet;
    console.debug('current', current)
    let { chit_info } = current;
    let {
      chit_amount,
      chit_draw_date,
      chit_due,
      chit_start_on,
      chit_subscribers,
      chit_tenure,
      chit_term_amount,
      chit_term_fee,
      nextTerm
    } = chit_info;

    let roles = Constants.extractRolesFromAccount(null);
    if (current._id !== 'default') {
      roles = Constants.extractRolesFromAccount(current);
    }

    let subCnt = 0;
    try {
        if (current.subscribers)
            subCnt = Object.keys(current.subscribers).length;
        console.debug('subCnt', subCnt);
    } catch (error) {
        console.error(error)
    }

    // if term = -1; chit matured
    // if term > 1; chit is active
    // if term = 1; chit is inactive
    // if term = undefined; chit not  yet started
    let chitNew = nextTerm === undefined;
    let chitInitiated = !chitNew && nextTerm === 1;
    let chitActive = !chitNew && nextTerm > 1;
    let chitMatured = !chitNew && nextTerm === -1;
    console.debug('chitInitiated', chitInitiated);
    console.debug('chitActive', chitActive);
    console.debug('chitMatured', chitMatured);

    let currentTerm;
    let currentTermDate;
    let nextTermDate;
    let nextChitInDays;
    
    console.debug('termDateMap', termDateMap)
    if (chitInitiated) {
      nextTermDate = moment(chit_start_on, "YYYY-MMM-DD").day(chit_draw_date).format("YYYY-MMM-DD")
      nextChitInDays = moment(nextTermDate, "YYYY-MMM-DD").diff(moment(), "d").toFixed()
    } 
    
    else if (chitActive) {
      currentTerm = nextTerm - 1;
      currentTermDate = moment(termDateMap[currentTerm], "YYYY-MMM-DD").date(chit_draw_date).format("YYYY-MMM-DD");
      nextTermDate = moment(currentTermDate, "YYYY-MMM-DD").add(1, "M").date(chit_draw_date).format("YYYY-MMM-DD")
      nextChitInDays = moment(nextTermDate, "YYYY-MMM-DD").diff(moment(), "d").toFixed()
    }


    return (
      <div className="content-fluid">
        <div className="row">
          <div className={"col-md-9 mx-auto"}>
            <div className="card">
              <div
                className="card-header"
                style={{
                  paddingLeft: "1em",
                  paddingRight: "1em",
                  paddingTop: "1em",
                  textAlign: "center",
                }}
              >
                <h4 className="card-title">{t('Manage Chitfund')}</h4>
                <p
                  className="card-category"
                  style={{ 
                    color: "#9C27B0", 
                    fontWeight: "500" 
                  }}
                >
                  {wallet.current._id === "default" ? "" : wallet.current.name}
                </p>
              </div>
              <div className="card-body" style={{ padding: "16px" }}>

                {subCnt === 0 && <div className="row">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">
                        {t('Setup Chitfund Members')}
                      </div>
                    </div>
                    <div className="card-body">
                      <p>{t('setup_subsribers_note')}</p>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={() => {
                          this._accountHandler
                            .addDummySubscribers(current._id)
                            .then(() => {
                              this._force_reload_account("/members?refresh=setup_members");
                            });
                        }}
                        disabled={!(roles.admin || roles.owner)}
                      >
                        Setup Members
                      </Button>
                    </div>
                  </div>
                </div>}
                        

                {subCnt > 0 && chitNew && <div className="row">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">
                        <span
                          style={{ fontSize: '1.2em', fontWeight: 400}}
                        >
                        {t('Chitfund Ready')}
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                    <p>{t('chitfund_ready_note')}</p>
                      <a href="/members" className="btn btn-link"  role="button">{t('Go to Chitfund Members')}</a>
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                          this._accountHandler
                            .startTheChit(wallet.current._id)
                            .then(() => {
                              this._force_reload_account("/manage?refresh=1")
                            });
                        }}
                        disabled={!chitNew || !(roles.admin || roles.owner)}
                      >
                      Start The chit
                      </Button>
                    </div>
                  </div>
                </div>}


                {(chitInitiated || chitActive) && <div className="row">
                  <div className="card"
                    style={{ backgroundColor: "rgb(103 58 183 / 47%)"}}
                  >
                    <div className="card-header"
                      style={{ backgroundColor: 'transparent'}}
                    >
                      <div className="card-title">
                        <span
                          style={{ fontSize: '1.2em', fontWeight: 400}}
                        >
                        {t('Chitfund Term Setup')}
                        </span>
                        {/* <span className="button"
                          onClick={()=>this.setState({ card_2_open: !card_2_open })}
                        ><span className="material-icons">keyboard_arrow_{card_2_open ? 'up' : 'down'}</span></span> */}

                        <button className="btn btn-primary" type="button" data-toggle="collapse" 
                                data-target="#multiCollapseExample2" 
                                aria-expanded="false" 
                                aria-controls="multiCollapseExample2"
                                onClick={()=>this.setState({ card_2_open: !card_2_open })}
                                style={{ float: "right", marginRight: "10px"}}
                                >
                                <span className="material-icons">{card_2_open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</span>
                        </button>
                      </div>
                    </div>
                    <div className={`collapse show`} id="multiCollapseExample2">
                      <div className="card-body">
                        <p>{t('chit_term_setup_note')}</p>
                        <ul
                          style={{ listStyle: 'none', marginLeft: '-2.0em'}}
                        >
                          {currentTerm && <li>Current chit term: {currentTerm}.</li>}
                          {currentTermDate && <li>Current chit draw date: {currentTermDate}.</li>}
                          {nextTerm > 0 && <li>Next chit term: {nextTerm}.</li>}
                          {nextTermDate && <li>Next chit date: {nextTermDate}.</li>}
                          {nextChitInDays && <li>Next chit in <span 
                                                                style={{ 
                                                                  color: `${nextChitInDays < 0 ? 'red' : 'blue'}`,
                                                                  fontWeight: 800,
                                                                }}
                                                              >
                                                                {nextChitInDays} days
                                                              </span>
                                            </li>}
                        </ul>
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={!(roles.admin || roles.owner)}
                          onClick={() => this.setState({ enableAddChitTerm: true })}
                        >
                        {t('Take Chit Draw')}
                        </Button>
                        {this.renderModalNewChitTermTran(nextTermDate)}
                      </div>
                    </div>
                  </div>
                </div>}


                {(chitActive || chitMatured) && <div className="row">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">
                        <span
                          style={{ fontSize: '1.2em', fontWeight: 400}}
                        >
                        {t('Reset Last Chit Term')}
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      <p>{t('chit_term_discard_note')}</p>
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={!(chitActive || chitMatured) || !(roles.admin || roles.owner)}
                        onClick={() => this.handleDeleteLastTerm(currentTerm)}
                      >
                      {t('Withdraw Last Term')}
                      </Button>
                    </div>
                  </div>
                </div>}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withSnackbar(
    withTranslation()(
      Manage
    )
  )
);
